import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ROLE_HOME = {
  super_admin:    "/super-admin",
  org_admin:      "/org",           // NEW — Phase B
  facility_admin: "/admin",
  staff:          "/staff",
};

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();
  const location          = useLocation();

  if (loading) {
    return (
      <div className="eq-loading-screen">
        <div className="eq-loading-spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user.mustChangePassword && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    const home = ROLE_HOME[user.role] || "/login";
    return <Navigate to={home} replace />;
  }

  return children;
}

export function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="eq-loading-screen">
        <div className="eq-loading-spinner" />
      </div>
    );
  }
  if (user && !user.mustChangePassword) {
    const home = ROLE_HOME[user.role] || "/login";
    return <Navigate to={home} replace />;
  }
  return children;
}
